import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdStructuralTemplateCanvasTemplateCacheKeys: AllRouteEndpoints[] = [];
